import { OptionTel } from "../types/option-tel.interface"

export const options: OptionTel[] = [
    { id: "--", value: "--", placeholder: "(99) 9999 9999" },
    { id: "MX +52", value: "MX +52", placeholder: "(99) 9999 9999" },
    { id: "US +1", value: "US +1", placeholder: "(999) 999 9999" },
    { id: "CO +57", value: "CO +57", placeholder: "(99) 9999 9999" },
    { id: "FR +3", value: "FR +3", placeholder: "(99) 999 99 99 99" },
]
